module.exports = __webpack_public_path__ + "static/media/BTC.9fc4d76f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/BTC.svg
// module id = 1492
// module chunks = 85